import dayjs from 'dayjs';
import isToday from 'dayjs/plugin/isToday';
import isYesterday from 'dayjs/plugin/isYesterday';

/* eslint-disable import-x/no-named-as-default-member */
dayjs.extend(isToday);
dayjs.extend(isYesterday);

export const formatDateMonth = (dateString: string): string => {
  return dayjs(new Date(dateString)).format('D.M.');
};

export const getDateInWords = (dateString: string): string => {
  const dateTime = dayjs(dateString);
  const date = dateTime.startOf('day');
  const now = dayjs();

  const daysFromToday = now.diff(date, 'days');

  if (dayjs(date).isToday()) {
    return dateTime.format('HH:mm');
  }

  if (dayjs(date).isYesterday()) {
    return 'Eilen';
  }

  if (daysFromToday >= 2 && daysFromToday <= 7) {
    return `${daysFromToday} päivää sitten`;
  }

  return dateTime.format('DD.MM.YYYY');
};
